<template>
<div class="chapter">
<div class="inner_page">
<h2 class="fm-title">Contents</h2>
<p class="toc-chap"><a href="#/xhtml/fm01">Prologue (A Parable)</a></p>
<p class="toc-chap"><a href="#/xhtml/fm02">Introduction</a></p>
<p class="toc-chap"><span href="#/xhtml/chap01" title="Link target outside of Sample">What Is Forgiveness?</span></p>
<p class="toc-chap"><span href="#/xhtml/chap02" title="Link target outside of Sample">Myths of Forgiving</span></p>
<p class="toc-chap"><span href="#/xhtml/chap03" title="Link target outside of Sample">Why We Struggle With Forgiving</span></p>
<p class="toc-chap"><span href="#/xhtml/step01" title="Link target outside of Sample">STEP 1: Decide To Forgive</span></p>
<p class="toc-chap"><span href="#/xhtml/step02" title="Link target outside of Sample">STEP 2: Enemy to Empathy—See The Person As Human</span></p>
<p class="toc-chap"><span href="#/xhtml/step03" title="Link target outside of Sample">STEP 3: Breathe and Release—Let The Memories Pass</span></p>
<p class="toc-chap"><span href="#/xhtml/step04" title="Link target outside of Sample">STEP 4: Learn The Lessons</span></p>
<p class="toc-chap"><span href="#/xhtml/step05" title="Link target outside of Sample">STEP 5: Accept Your Role (And Choose Your Role)</span></p>
<p class="toc-chap"><span href="#/xhtml/step06" title="Link target outside of Sample">STEP 6: Re-Decide and Reinforce</span></p>
<p class="toc-chap"><span href="#/xhtml/bm01" title="Link target outside of Sample">Q &amp; A on Forgiving</span></p>
<p class="toc-chap"><span href="#/xhtml/bm02" title="Link target outside of Sample">Endings and Beginnings</span></p>
<p class="toc-chap"><span href="#/xhtml/bm03" title="Link target outside of Sample">About The Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?a23f445e